import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
export const MobileVersionsTab = /*#__PURE__*/ memo(()=>{
    const { showPanel } = useAssetModalPanelContext();
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        "data-testid": "VERSIONS_PANEL",
        icon: Stack,
        onClick: ()=>showPanel(AssetModalPanel.VERSIONS),
        size: "large",
        label: "Versions panel"
    });
});
MobileVersionsTab.displayName = "MobileVersionsTab";
